import { SelectHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

const Select = forwardRef<HTMLSelectElement, SelectProps>(({ className, ...props }, ref) => {
  return (
    <select
      className={cn(
        'glass-input flex h-10 w-full px-3 py-2 text-sm text-glass-text disabled:cursor-not-allowed disabled:opacity-50',
        /* Reinforce option contrast when native list ignores theme tokens */
        '[&>option]:bg-glass-2 [&>option]:text-glass-text',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Select.displayName = 'Select';

export default Select;
